// extracted by mini-css-extract-plugin
module.exports = {"textarea":"VYC1s7","noresize":"bKL1DT"};